<template>
  <div>
    <!-- cabecalho editorial -->
    <header class="chead">
      <div class="chead__text">
        <p class="chead__eyebrow">{{ eyebrow }}</p>
        <h1 class="chead__title">{{ title }}</h1>
        <p v-if="subtitle" class="chead__sub">{{ subtitle }}</p>
      </div>
      <slot name="action"></slot>
    </header>

    <!-- legenda da rampa de niveis -->
    <div v-if="showRamp" class="ramp" aria-hidden="true">
      <span class="ramp__label">{{ $t("course.ladder") }}</span>
      <template v-for="(t, i) in ramp">
        <span :key="'a' + i" v-if="i > 0" class="ramp__arrow">→</span>
        <span :key="'s' + i" class="ramp__step">
          <span class="ramp__dot" :style="{ background: t.color }"></span
          >{{ t.key }}
        </span>
      </template>
    </div>
  </div>
</template>

<script>
import { RAMP_TIERS } from "@/shared/courseTiers";

export default {
  name: "CourseHeader",
  props: {
    eyebrow: { type: String, default: "Pitch English · Connect" },
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    showRamp: { type: Boolean, default: true },
  },
  data() {
    return { ramp: RAMP_TIERS };
  },
};
</script>

<style scoped>
.chead {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  padding-bottom: 28px;
  border-bottom: 1px solid var(--dk-line, #eae7f0);
}
.chead__eyebrow {
  margin: 0 0 14px;
  font-family: "Poppins", sans-serif;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--dk-faint, #9a96a6);
}
.chead__title {
  margin: 0;
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  font-size: clamp(2rem, 5vw, 3rem);
  line-height: 0.98;
  letter-spacing: -0.015em;
  color: var(--dk-ink, #211b2e);
}
.chead__sub {
  margin: 14px 0 0;
  max-width: 48ch;
  font-family: "Poppins", sans-serif;
  font-size: 15px;
  line-height: 1.55;
  color: var(--dk-ink-soft, #6e6a79);
}

.ramp {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 20px;
  margin: 22px 0 36px;
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  color: var(--dk-faint, #9a96a6);
}
.ramp__label {
  margin-right: 4px;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}
.ramp__step {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-weight: 500;
  color: var(--dk-ink-soft, #6e6a79);
}
.ramp__dot {
  width: 10px;
  height: 10px;
  border-radius: 3px;
  flex: none;
}
.ramp__arrow {
  color: var(--dk-line-strong, #c9c4d4);
}
</style>
